import FilterTextField from '../baseInputTypes/FilterTextField'

export const RatingKva = () => (
  <FilterTextField
    type="number"
    label="kVA"
    fieldPath={'productInformation.ratings.kva'}
  />
)

export const RatingBkw = () => (
  <FilterTextField
    type="number"
    label="bkW"
    fieldPath={'productInformation.ratings.bkw'}
  />
)

export const RatingBhp = () => (
  <FilterTextField
    type="number"
    label="bhp"
    fieldPath={'productInformation.ratings.bhp'}
  />
)

export const RatingEkw = () => (
  <FilterTextField
    type="number"
    label="ekW"
    fieldPath={'productInformation.ratings.ekw'}
  />
)

export const RatingMhp = () => (
  <FilterTextField
    type="number"
    label="mhp"
    fieldPath={'productInformation.ratings.mhp'}
  />
)
